import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './SportsPage.css';
import cricketWomanImage from "../assets/cricketWomanImage.png"
import logo from "../assets/bg-remover-logo.png"
function SportsPage() {
  const location = useLocation();
  const sportId = location.pathname.substring(1); // Remove the leading slash
  const navigate = useNavigate();


  // Sports data
  const sportsData = {
    'sports-fitness': {
      title: 'Sports Fitness For Athletes',
      description: 'Comprehensive fitness training programs designed specifically for athletes to enhance performance, build strength, and improve endurance.',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=800&h=600&fit=crop&crop=center',
      content: 'Our sports fitness programs are tailored to meet the unique demands of athletic performance. We focus on functional training, sport-specific conditioning, and injury prevention to help athletes reach their peak potential.',
      detailedContent: {
        introduction: 'Sports fitness, often referred to as sports training or athletic conditioning, is a specialized process of preparing athletes and sportspeople to achieve and maintain a high level of performance in their specific sport. Unlike general fitness, which aims for overall health, sports fitness is tailored to the unique demands of a particular sport, focusing on the physical, mental, and tactical components necessary for success.',
        keyComponents: [
          {
            title: 'Physical Fitness',
            description: 'This is the foundation of athletic performance and includes:',
            items: [
              'Strength: The ability of muscles to exert force. This is crucial for power, speed, and injury prevention.',
              'Speed: The ability to move quickly, both in a straight line and with rapid changes in direction.',
              'Endurance: The ability to perform a prolonged activity without fatigue. This is vital for long-duration sports and for maintaining performance throughout a game or match.',
              'Flexibility and Mobility: The range of motion of joints and the ability to move freely. It helps prevent injuries and improve movement efficiency.',
              'Agility: The ability to change direction and move quickly while maintaining control.',
              'Coordination: The ability to use different parts of the body together smoothly and efficiently.'
            ]
          },
          {
            title: 'Technical Skills',
            description: 'This involves the sport-specific movements and techniques required to perform at a high level. It\'s about refining the mechanics of a sport, such as a tennis serve, a basketball shot, or a soccer kick.'
          },
          {
            title: 'Tactical Efficiency',
            description: 'This component focuses on the strategic aspects of a sport. It includes understanding game situations, analyzing opponents\' tactics, and making quick decisions to maximize the chances of success. This is often developed through practice, game-like scenarios, and mental preparation.'
          },
          {
            title: 'Mental and Psychological Abilities',
            description: 'The mental game is just as important as the physical one. This includes:',
            items: [
              'Focus and Concentration: The ability to block out distractions and stay present in the moment.',
              'Resilience and Confidence: The ability to bounce back from setbacks and maintain a positive self-belief.',
              'Stress and Anxiety Management: The ability to handle the pressure of competition.',
              'Discipline and Dedication: The commitment to consistent training and self-improvement.'
            ]
          }
        ],
        improvementMethods: [
          {
            title: 'Training Programs',
            description: 'These are structured, periodized plans that combine different types of workouts. A typical program might include:',
            items: [
              'Strength and Conditioning: Using weights, resistance bands, and bodyweight exercises to build muscle, power, and endurance.',
              'Speed and Agility Drills: Exercises like cone drills, ladder exercises, and sprinting to improve quickness and directional changes.',
              'High-Intensity Interval Training (HIIT): Short bursts of intense exercise followed by brief recovery periods to improve cardiovascular fitness.',
              'Sport-Specific Drills: Practicing movements and scenarios that directly mimic the demands of the sport.',
              'Cross-Training: Engaging in activities outside the primary sport (e.g., swimming for a basketball player) to prevent burnout and reduce the risk of overuse injuries.'
            ]
          },
          {
            title: 'Nutrition and Hydration',
            description: 'Proper fueling is critical for performance and recovery. Athletes focus on:',
            items: [
              'Carbohydrates: The primary source of energy for muscles.',
              'Protein: Essential for muscle growth and repair.',
              'Healthy Fats: Provide a source of energy and support overall health.',
              'Hydration: Maintaining adequate fluid and electrolyte levels before, during, and after exercise to prevent dehydration and fatigue.'
            ]
          },
          {
            title: 'Recovery and Rest',
            description: 'This is a crucial, yet often overlooked, part of sports fitness. It allows the body to repair and rebuild after strenuous training. This includes:',
            items: [
              'Adequate Sleep: Aiming for 7-9 hours of quality sleep per night.',
              'Active Recovery: Light activities like walking or stretching to reduce muscle soreness.',
              'Massage and Foam Rolling: To relieve muscle tension and improve flexibility.',
              'Rest Days: Taking time off from training to prevent overtraining and injury.'
            ]
          },
          {
            title: 'Mental Conditioning',
            description: 'Athletes use techniques like visualization, meditation, and positive affirmations to improve focus, confidence, and resilience.'
          }
        ],
        conclusion: 'In essence, sports fitness is a holistic and continuous process that goes beyond just physical exercise. It\'s a long-term commitment to developing all the components—physical, technical, tactical, and mental—that are essential for an athlete to reach their peak potential.'
      }
    },
    'badminton': {
      title: 'Badminton Training',
      description: 'Professional badminton coaching with focus on technique, strategy, and physical conditioning for players of all levels.',
      image: 'https://www.activesgcircle.gov.sg/hubfs/Imported_Blog_Media/Coach%20Wong%203-1.jpeg',
      content: 'Our badminton program emphasizes proper technique, footwork, and tactical awareness. We provide comprehensive training that covers all aspects of the game from beginner to professional level.',
      detailedContent: {
        introduction: 'Badminton is a sport that requires a combination of skill, fitness, and strategy. Whether you\'re a beginner or an aspiring champion, the journey from one level to the next involves dedicated practice and a structured approach.',
        pathToChampion: {
          title: 'The Path to a Champion',
          description: 'Becoming a champion requires a holistic approach From a beginner\'s first serve to a champion\'s decisive smash, that includes elite-level skills, intense physical and mental training, and a deep understanding of the game.',
          trainingSchedule: {
            title: 'Professional-Level Training',
            description: 'A typical professional training schedule is intense and balanced:',
            onCourtTraining: {
              title: 'On-Court Training',
              description: 'Spend several hours a day on the court, focusing on high-volume drills, multi-shuttle training, and match-like simulations. This builds speed, endurance, and lactic acid tolerance.'
            },
            offCourtTraining: {
              title: 'Off-Court Training',
              description: 'Your physical conditioning becomes more specialized.',
              components: [
                {
                  title: 'Strength and Power',
                  description: 'Focus on functional, full-body movements with weights to develop strength and explosive power.'
                },
                {
                  title: 'Endurance',
                  description: 'Engage in high-intensity interval training (HIIT) and distance running to build a high level of cardiovascular fitness.'
                },
                {
                  title: 'Flexibility and Recovery',
                  description: 'Incorporate yoga, stretching, and other recovery techniques like ice baths to prevent injuries and aid muscle repair.'
                }
              ]
            }
          },
          mentalTactical: {
            title: 'Mental and Tactical Mastery',
            components: [
              {
                title: 'Match Analysis',
                description: 'Use video analysis to break down your own games and study your opponents\' strengths and weaknesses.'
              },
              {
                title: 'Sports Psychology',
                description: 'Work on your mental toughness, focus, and confidence. Techniques like visualization and positive self-talk are essential for high-pressure situations.'
              },
              {
                title: 'Strategic Study',
                description: 'Develop a deep understanding of court geometry, shot placement, and how to construct winning rallies.'
              }
            ]
          },
          conclusion: 'By following this progressive path—building a solid foundation, refining your skills, and embracing a champion\'s mind set—you can elevate your game from a beginner to a true competitor.'
        }
      }
    },
    'table-tennis': {
      title: 'Table Tennis Training',
      description: 'Expert table tennis coaching focusing on precision, speed, and strategic gameplay for competitive players.',
      image: 'https://cdn.gerflor.com/media/1642426083/1/31383.jpg',
      content: 'Our table tennis program develops hand-eye coordination, quick reflexes, and strategic thinking. We train players to master both offensive and defensive techniques.',
      detailedContent: {
        introduction: 'The journey in table tennis is a blend of technical mastery, strategic thinking, physical conditioning, and mental fortitude. This guide will take you through the key stages of development, providing a roadmap for your progression in the sport.',
        championLevel: {
          title: 'The Champion (Peak Performance)',
          description: 'Reaching the champion level requires a holistic approach that goes beyond just table time. It involves physical conditioning, mental strength, and a disciplined lifestyle.',
          physicalConditioning: {
            title: 'Physical Conditioning',
            description: 'Table tennis is a highly physical sport that demands speed, agility, and stamina.',
            components: [
              {
                title: 'Stamina',
                description: 'Incorporate distance running or multi-ball drills into your training.'
              },
              {
                title: 'Speed and Agility',
                description: 'Use exercises like skipping, ladder drills, and shadow play to improve footwork and reaction time.'
              },
              {
                title: 'Strength',
                description: 'Focus on core and lower body strength with exercises like lunges and planks, which are essential for explosive movements and balance.'
              },
              {
                title: 'Flexibility',
                description: 'Regular stretching before and after sessions is crucial to prevent injuries.'
              }
            ]
          },
          nutrition: {
            title: 'Nutrition and Diet',
            description: 'Fuel your body for peak performance.',
            components: [
              'A professional table tennis player\'s diet is high in carbohydrates (7-8g per kg of body weight daily) to replenish glycogen stores.',
              'Moderate protein intake is needed for muscle repair.',
              'Focus on nutrient-rich foods like breads, cereals, fruits, and vegetables.',
              'Proper hydration is non-negotiable, especially during long matches or tournaments.'
            ]
          },
          mentalToughness: {
            title: 'Mental Toughness',
            description: 'The most significant differentiator at the elite level is mental game.',
            components: [
              {
                title: 'Focus on the Process',
                description: 'Don\'t get caught up in the score or the outcome. Focus on the next point, the next shot.'
              },
              {
                title: 'Positive Self-Talk',
                description: 'Engage in positive affirmations and celebrate your points, both internally and externally. This builds confidence and signals strength to your opponent.'
              },
              {
                title: 'Perfect Your Routine',
                description: 'Develop a routine between points (e.g., taking a deep breath, drying your hand) to reset and refocus.'
              },
              {
                title: 'Problem-Solving',
                description: 'During a match, if you\'re losing, analyze why and be prepared to change your tactics.'
              },
              {
                title: 'Embrace Losing',
                description: 'View losses as learning opportunities. Analyze what went wrong and use that information to improve your game.'
              },
              {
                title: 'Visualization and Meditation',
                description: 'Use these techniques to enhance focus, calmness, and prepare your mind for competitive scenarios.'
              }
            ]
          },
          conclusion: 'By consistently applying these principles, you can transform your game from a casual hobby into a serious pursuit and, with dedication, become a true champion of the sport.'
        }
      }
    },
    'athletes': {
      title: 'Athletes Development',
      description: 'Comprehensive athlete development programs covering physical training, mental conditioning, and performance optimization.',
      image: 'https://media.istockphoto.com/id/533993716/photo/sport-sprinter-leaving-starting-blocks-on-the-running-track.jpg?s=612x612&w=0&k=20&c=BT1ZLBQFFfUwQA8eQObpHI7VOFUQDtQE1qaDHA6Gels=',
      content: 'Our athlete development program focuses on holistic training including physical conditioning, mental toughness, nutrition guidance, and recovery strategies.',
      detailedContent: {
        introduction: 'Embarking on the journey from a beginner to an athletics champion is a multi-faceted process that involves consistent physical training, mental fortitude, and a strategic approach. It\'s not just about natural talent; it\'s a holistic commitment to a lifestyle of discipline and continuous improvement.',
        championPath: {
          title: 'The Champion\'s Path: Elite Performance and Longevity 🏆',
          description: 'Becoming a champion requires more than just physical ability; it demands a deep commitment to the sport as a lifestyle. (Choose your Event:- eg, Sprint, Middle distance running, long distance running, Jumps, Throws, Heptathlon and Decathlon)',
          trainingPrinciples: {
            title: 'Training Principles',
            description: 'Master the finer details: Champions are masters of the mundane. They meticulously track their training, monitor their sleep, and pay attention to every detail of their recovery, including stretching, foam rolling, and mobility work.',
            components: [
              {
                title: 'Refine technique',
                description: 'Work with your coach to continuously analyze and perfect your technique. Even a slight improvement in form can lead to significant gains at the elite level.'
              },
              {
                title: 'Incorporate advanced training',
                description: 'This may include plyometrics, advanced strength training, and sport-specific drills to maximize power and speed.'
              },
              {
                title: 'Strategic competition',
                description: 'Champions choose their races wisely, focusing on key events where they want to peak. They also learn how to execute race strategies, such as pacing and tactical moves.'
              }
            ]
          },
          mindset: {
            title: 'Mindset',
            components: [
              {
                title: 'Develop a "growth mindset"',
                description: 'Believe that your abilities can be developed through dedication and hard work. See setbacks and failures as opportunities to learn and grow, not as proof of your limitations.'
              },
              {
                title: 'Visualize success',
                description: 'Mental rehearsal is a powerful tool. Champions visualize themselves executing their race plan perfectly and crossing the finish line victorious.'
              },
              {
                title: 'Cultivate mental toughness',
                description: 'This involves staying calm under pressure, bouncing back from disappointment, and maintaining an unwavering belief in yourself, even when facing tough competition.'
              },
              {
                title: 'Build a support system',
                description: 'Surround yourself with a team of people who support your goals, including coaches, teammates, family, and friends.'
              }
            ]
          }
        }
      }
    },
    'boxing': {
      title: 'Boxing Training',
      description: 'Professional boxing training with emphasis on technique, conditioning, and mental preparation for competitive boxing.',
      image: 'https://images.pexels.com/photos/163403/box-sport-men-training-163403.jpeg?cs=srgb&dl=pexels-pixabay-163403.jpg&fm=jpg',
      content: 'Our boxing program teaches proper technique, footwork, and defensive skills while building strength, endurance, and mental toughness required for competitive boxing.',
      detailedContent: {
        introduction: 'Boxing is a sport that demands a unique combination of physical and mental toughness. The journey from a beginner to a champion is a long and arduous one, but with the right training, mindset, and dedication, it is an achievable goal.',
        aspiringChampion: {
          title: 'The Aspiring Champion: Stepping Up Your Game',
          description: 'Once you have a solid grasp of the basics, it\'s time to intensify your training and expand your skill set.',
          physicalConditioning: {
            title: 'Elevate your physical conditioning',
            description: 'Boxing requires immense stamina. Your training should include:',
            components: [
              {
                title: 'Road work',
                description: 'Long-distance running or sprinting to build cardiovascular endurance.'
              },
              {
                title: 'Calisthenics',
                description: 'Bodyweight exercises like push-ups, squats, and sit-ups to build overall strength.'
              },
              {
                title: 'High-intensity interval training (HIIT)',
                description: 'Drills that mimic the pace of a boxing match, like rounds of heavy bag work followed by short rest periods.'
              }
            ]
          },
          advancedTechniques: {
            title: 'Learn advanced techniques and defence',
            components: [
              {
                title: 'Defences',
                description: 'Just as important as offense. Learn to block, slip (move your head to the side to avoid a punch), and duck (bend at the knees to avoid a hook or cross).'
              },
              {
                title: 'Combinations',
                description: 'Practice more complex punch combinations to keep your opponent guessing.'
              },
              {
                title: 'Sparring',
                description: 'This is a crucial step for any aspiring boxer. Sparring allows you to practice your skills against a live opponent, learn to handle pressure, and improve your timing and reflexes. Start with light, controlled sparring and gradually increase the intensity as you gain experience.'
              },
              {
                title: 'Compete as an amateur',
                description: 'To truly test your skills and gain valuable experience, you must participate in amateur fights. This will prepare you for the psychological and physical demands of an actual bout.'
              }
            ]
          }
        },
        pathToProfessionalism: {
          title: 'The Path to Professionalism: The Final Ascent',
          description: 'Becoming a professional boxer is a full-time commitment that requires a new level of dedication.',
          components: [
            {
              title: 'Gain a professional license',
              description: 'Once you\'ve had a successful amateur career, you can apply for a professional boxing license from a governing commission. This is the official transition from an unpaid amateur to a paid professional.'
            },
            {
              title: 'Find a manager and promoter',
              description: 'A good manager will handle the business side of your career, from negotiating contracts to finding you fights. A promoter will help you get opportunities and build your reputation.'
            },
            {
              title: 'Intensify your training regimen',
              description: 'The stakes are higher in professional boxing, and so is the training. Champions like Mike Tyson and Floyd Mayweather are known for their grueling daily routines, which include long runs, countless rounds of sparring, and a meticulous focus on diet and recovery.'
            },
            {
              title: 'Cultivate mental toughness',
              description: 'The difference between a good boxer and a champion is often their mental fortitude. Champions possess:',
              subComponents: [
                'Confidence: A strong belief in their abilities, built through consistent training and small victories.',
                'Focus: The ability to stay present and block out distractions, both in and out of the ring.',
                'Resilience: The mental strength to push through exhaustion, recover from a knockdown, and bounce back from a loss.',
                'Discipline: The self-motivation to stick to a rigorous training and diet plan, even when it\'s difficult.'
              ]
            }
          ],
          conclusion: 'Remember, the journey from beginner to champion is not linear. There will be setbacks, plateaus, and moments of doubt. But with persistence, the right training, and an unwavering belief in yourself, you can achieve your boxing dreams.'
        }
      }
    },
    'shooting': {
      title: 'Shooting Sports',
      description: 'Precision shooting training for competitive shooting sports with focus on accuracy, concentration, and technique.',
      image: 'https://static.toiimg.com/thumb/msid-115538833,width-1280,height-720,imgsize-34144,resizemode-72,overlay-toi_sw,pt-32,y_pad-40/photo.jpg',
      content: 'Our shooting program emphasizes precision, concentration, and proper technique. We train athletes in various shooting disciplines with state-of-the-art equipment.',
      detailedContent: {
        introduction: 'Becoming a champion shooter is a journey that requires dedication, practice, and a systematic approach. Here\'s a breakdown of the path from a beginner to a champion shooter.',
        chooseDiscipline: {
          title: 'Choose Your Discipline',
          description: 'There are many types of shooting (e.g., pistol, rifle, shotgun, long-range, action shooting, bulls eye). Pick one that interests you.'
        },
        advancedPhase: {
          title: 'The Advanced Phase: Specialization and Mastery',
          description: 'This is where you begin to compete at a high level and refine your skills to an elite standard.',
          components: [
            {
              title: 'Advanced Drills',
              description: 'Incorporate more complex drills that challenge your speed and accuracy simultaneously.'
            },
            {
              title: 'Data Analysis',
              description: 'Start using shot timers and analyzing your performance. Identify your weaknesses and create specific drills to address them.'
            },
            {
              title: 'Physical Fitness',
              description: 'A strong core, good endurance, and hand strength are all beneficial for shooting, especially in disciplines that require you to hold a firearm for extended periods.'
            },
            {
              title: 'Mental Performance Coaching',
              description: 'Many elite athletes, including shooters, work with sports psychologists to improve their mental game, handle stress, and visualize success.'
            },
            {
              title: 'Specialization',
              description: 'Focus on the specific discipline you\'ve chosen and dive deep into its nuances. This might involve long-range wind reading, advanced shotgun lead, or fast pistol transitions.'
            },
            {
              title: 'High-Level Competition',
              description: 'Travel to regional and national competitions. Learn from the best shooters in the country.'
            }
          ]
        },
        championPhase: {
          title: 'The Champion Phase: Elite Performance and Consistency',
          description: 'This is the pinnacle of the sport, where winning is the expectation.',
          components: [
            {
              title: 'Consistency under Pressure',
              description: 'Champions can perform at their best even when the stakes are highest. This comes from thousands of hours of practice and a strong mental game.'
            },
            {
              title: 'Adaptability',
              description: 'A champion shooter can adapt to different conditions, ranges, and equipment.'
            },
            {
              title: 'Continuous Improvement',
              description: 'A champion never stops learning. They are always seeking to refine their technique and push their limits.'
            },
            {
              title: 'Coaching/Mentoring',
              description: 'Many champions become mentors themselves, passing on their knowledge to the next generation.'
            },
            {
              title: 'Physical and Mental Peak',
              description: 'Maintaining a high level of physical and mental fitness is crucial for a long and successful career.'
            }
          ],
          conclusion: 'Remember, the path from beginner to champion is a marathon, not a sprint. Celebrate your small victories, learn from your mistakes, and never stop pushing yourself to be better.'
        }
      }
    },
    'weightlifting': {
      title: 'Weightlifting Training',
      description: 'Professional weightlifting coaching focusing on proper technique, strength development, and competition preparation.',
      image: 'https://images.unsplash.com/photo-1521804906057-1df8fdb718b7?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8d2VpZ2h0JTIwbGlmdGluZ3xlbnwwfHwwfHx8MA%3D%3D&fm=jpg&q=60&w=3000',
      content: 'Our weightlifting program teaches proper lifting techniques, builds strength progressively, and prepares athletes for competitive weightlifting events.',
      detailedContent: {
        introduction: 'The journey from a beginner to a champion weightlifter is a long and demanding one, requiring a foundation of proper technique, a progressive training plan, and an elite mindset. Here\'s a breakdown of the path from novice to the podium.',
        layingFoundation: {
          title: 'Laying the Foundation',
          description: 'The initial phase is all about learning the basics and building a solid base of strength. The goal is not to lift the most weight, but to master the correct form to prevent injury and create good habits.',
          components: [
            {
              title: 'Prioritize Form Over Weight',
              description: 'Before you add any significant weight, practice the fundamental movements with just your body weight, an unweighted bar, or very light dumbbells. Focus on getting the movement patterns down for exercises like squats, deadlifts, and overhead presses.'
            },
            {
              title: 'Start with Full-Body Workouts',
              description: 'A good beginner routine will target all major muscle groups. You can work out 2-3 times per week, with a rest day in between to allow your muscles to recover. A sample routine might include:',
              subComponents: [
                'Squats: Build a strong lower body and core.',
                'Deadlifts: Develop overall strength in your back, glutes, and hamstrings.',
                'Bench Press: Target your chest, shoulders, and triceps.',
                'Bent-Over Rows: Strengthen your back and biceps.',
                'Overhead Press: Improve shoulder strength and stability.'
              ]
            }
          ]
        },
        champion: {
          title: 'Champion: The Pinnacle of the Sport',
          description: 'At the champion level, every aspect of training is meticulously planned and executed. The margins for error are minuscule.',
          components: [
            {
              title: 'Technique Perfection',
              description: 'Champions are constantly refining their technique. They use "corrective drills" and exercises to fix even the slightest flaw in their form. They understand that every single repetition, from the warm-up to the final lift, is an opportunity to improve.'
            },
            {
              title: 'Holistic Approach',
              description: 'A champion\'s training extends beyond the lifts themselves. It includes:',
              subComponents: [
                'Overall Physical Development: Improving aerobic and anaerobic systems, speed, agility, and flexibility.',
                'Psychological Preparation: Developing intense concentration, visualization, and the ability to relax under pressure.',
                'Specific Preparation: The training is highly tailored to the athlete\'s body and goals.'
              ]
            },
            {
              title: 'Continuous Improvement',
              description: 'The ultimate goal is to consistently set new personal records, especially in competition. A champion\'s mindset is one of continuous growth, always looking for ways to get better.'
            }
          ]
        }
      }
    },
    'cricket-women': {
      title: 'Cricket (Women)',
      description: 'Specialized cricket training programs for women athletes focusing on technique, fitness, and competitive play.',
      image: cricketWomanImage,
      content: 'Our women\'s cricket program provides comprehensive training covering batting, bowling, fielding, and fitness specifically designed for female athletes.',
      detailedContent: {
        introduction: 'A Women\'s cricket is not in vogue in India, although a woman\'s journey from a beginner to a champion in cricket is a process that requires dedication, skill development, and a clear understanding of the pathway to professional play.',
        learnBasics: {
          title: 'Learn the Basics',
          components: [
            {
              title: 'Understand the rules',
              description: 'Familiarize yourself with the rules and different formats of cricket, such as T20, One Day Internationals (ODIs), and Test matches.'
            },
            {
              title: 'Get the right equipment',
              description: 'Use equipment suited to your size and strength. A lightweight bat and well-fitted protective gear (helmet, gloves, pads, thigh pads, etc.) are essential for safety and comfort.'
            }
          ]
        },
        developSkills: {
          title: 'Develop Foundational Skills',
          components: [
            {
              title: 'Technical Skills',
              description: 'Focus on the fundamentals of batting (stance, footwork, hand-eye coordination), bowling (action, accuracy, variations), and fielding (catching, throwing, agility).'
            },
            {
              title: 'Physical Fitness',
              description: 'Cricket is a physically demanding sport. Start with basic exercises to build cardiovascular fitness, strength, and stamina. This includes running, jogging, and general bodyweight exercises.'
            },
            {
              title: 'Mental Strength',
              description: 'Learn to handle pressure and stay committed to your goals. The journey requires a lot of hard work and patience.'
            }
          ]
        },
        specializedTraining: {
          title: 'Specialized Training',
          description: 'As you progress, identify your strengths and weaknesses. Decide if you want to be a specialist batter, bowler, or an all-rounder.',
          components: [
            {
              title: 'Strength & Conditioning',
              description: 'Professional players follow a structured training regimen that includes strength, speed, and agility training. This helps in developing power for batting, speed for bowling, and quickness for fielding.'
            },
            {
              title: 'Core Training',
              description: 'A strong core is essential for balance, stability, and rotational power in both batting and bowling. Incorporate exercises like planks and Russian twists.'
            },
            {
              title: 'Flexibility and Mobility',
              description: 'Regular stretching and mobility drills are crucial for injury prevention and improving overall performance.'
            }
          ]
        },
        champion: {
          title: 'The Champion (Reaching the Elite Level)',
          pathway: {
            title: 'The Pathway to Professional Cricket',
            description: 'The path to becoming a professional cricketer involves a series of selection trials and progression through different levels of the game.',
            components: [
              {
                title: 'State-Level',
                description: 'Excel in state-level tournaments to get selected for the state team.'
              },
              {
                title: 'Domestic Leagues',
                description: 'Play in major domestic tournaments and leagues.'
              },
              {
                title: 'National Team',
                description: 'Consistent top-tier performance at the domestic level can lead to selection for the national team.'
              }
            ]
          },
          professionalTraining: {
            title: 'Professional Training & Lifestyle',
            description: 'At this stage, training is highly specialized and rigorous. It includes:',
            components: [
              {
                title: 'High-Intensity Drills',
                description: 'Match simulations, advanced technical drills with bowling machines, and focused practice sessions.'
              },
              {
                title: 'Advanced Fitness Regimen',
                description: 'A strength and conditioning coach will design a program to optimize performance, focusing on power, explosive movements, and endurance specific to cricket.'
              },
              {
                title: 'Diet and Nutrition',
                description: 'A strict diet is essential to maintain peak physical condition.'
              },
              {
                title: 'Recovery',
                description: 'Proper rest and recovery techniques are as important as training.'
              }
            ]
          },
          continuousImprovement: {
            title: 'Continuous Improvement',
            description: 'Even at the highest level, the best players never stop learning. They analyze their performance, work on weaknesses, and adapt their game to different formats and opponents.',
            conclusion: 'Mentorship from current and former players and coaches is invaluable for navigating the challenges of professional cricket. By following this pathway, a beginner can systematically build their skills and experience to achieve their dream of becoming a champion in women\'s cricket.'
          }
        }
      }
    },
    'tennis': {
      title: 'Tennis Training',
      description: 'Professional tennis coaching with focus on technique, strategy, and physical conditioning for competitive tennis.',
      image: 'https://png.pngtree.com/thumb_back/fh260/background/20221214/pngtree-young-girls-playing-tennis-game-indoor-recreation-set-tenis-photo-image_42970976.jpg',
      content: 'Our tennis program develops all aspects of the game including technique, footwork, strategy, and mental toughness required for competitive tennis.',
      detailedContent: {
        introduction: 'Embarking on the journey from a tennis beginner to a champion is a multi-faceted endeavor that requires dedication, strategic training, and a deep understanding of the game.',
        technicalStrategic: {
          title: 'Technical & Strategic Development',
          components: [
            {
              title: 'Live Drills',
              description: 'Practice live drills and play points with friends or family. This will help you get comfortable with the flow of a match.'
            },
            {
              title: 'Advanced Shots',
              description: 'Start incorporating more advanced shots into your game, such as the slice, topspin, and different serve variations (e.g., slice serve, kick serve).'
            },
            {
              title: 'Match Play',
              description: 'Compete in friendly matches to test your skills and learn to think strategically. Focus on placing the ball strategically rather than just hitting it as hard as you can.'
            },
            {
              title: 'Opponent Analysis',
              description: 'Learn to identify your opponent\'s weaknesses and adjust your game plan accordingly. Playing against better players is a great way to improve, as you\'ll be forced to elevate your game.'
            }
          ]
        },
        physicalMental: {
          title: 'Physical and Mental Training',
          components: [
            {
              title: 'Strength & Conditioning',
              description: 'Focus on a tennis-specific fitness routine. This includes exercises for your core, legs, and upper body. Squats, lunges, and deadlifts are great for building lower-body power.'
            },
            {
              title: 'Mental Toughness',
              description: 'Tennis is a highly mental sport. Start incorporating mental training techniques into your routine.',
              subComponents: [
                'Visualization: Picture yourself executing perfect shots and winning key points.',
                'Positive Self-Talk: Replace negative thoughts with positive affirmations.',
                'Breathing and Relaxation: Use deep breathing exercises to stay calm under pressure.',
                'Routines: Develop pre-point and pre-match routines to stay focused and manage nerves.'
              ]
            }
          ]
        },
        champion: {
          title: 'Stage 3: The Champion',
          description: 'Reaching a championship level requires a full-time commitment to the sport. This is where your passion and dedication are truly tested.',
          roadToProfessionalism: {
            title: 'The Road to Professionalism',
            components: [
              {
                title: 'Compete in Tournaments',
                description: 'Start with local and national junior tournaments. As you improve, you\'ll move up to international tournaments sanctioned by organizations like the ITF (International Tennis Federation).'
              },
              {
                title: 'Join an Academy',
                description: 'Enrolling in a tennis academy can provide year-round training, a competitive environment, and expert coaching.'
              },
              {
                title: 'Intense Training',
                description: 'Professional players train for several hours a day, often six days a week. This includes on-court practice, fitness training, and flexibility work.'
              },
              {
                title: 'Build a Team',
                description: 'Surround yourself with a dedicated team, including a private coach, fitness trainer, and possibly a mental coach or sports psychologist.'
              },
              {
                title: 'Professional Tour',
                description: 'Success in junior and amateur tournaments will earn you ranking points, allowing you to enter professional events. You\'ll start on the lower-level circuits, such as the Challenger Tour, to earn ATP/WTA points and improve your ranking. The goal is to progressively work your way up to the main tours and major tournaments like the Grand Slams.'
              }
            ],
            conclusion: 'The path from beginner to champion is a long and challenging one, but with consistent practice, a strategic approach, and unwavering mental fortitude, it is a goal that can be achieved.'
          }
        }
      }
    },
    'volleyball': {
      title: 'Volleyball Training',
      description: 'Comprehensive volleyball training focusing on technique, teamwork, and competitive play for all skill levels.',
      image: 'https://images.unsplash.com/photo-1567880325673-ccc01edca61c?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fHZvbGxleWJhbGx8ZW58MHx8MHx8fDA%3D&fm=jpg&q=60&w=3000',
      content: 'Our volleyball program emphasizes proper technique, team coordination, and strategic play. We train players in all positions and skills required for competitive volleyball.',
      detailedContent: {
        introduction: 'Becoming a champion in any sport, including volleyball, is a journey of dedication, practice, and continuous improvement. It involves mastering fundamental skills, developing a strong physical foundation, and evolving your understanding of the game\'s strategy and tactics.',
        beginner: {
          title: 'The Beginner (Learning the Fundamentals)',
          description: 'At this stage, your primary focus is on learning the basic rules and developing proper technique for the core skills. Consistency is more important than power.',
          keySkills: {
            title: 'Key Skills to Master',
            components: [
              {
                title: 'Serving',
                description: 'The action that starts every rally.',
                subComponents: [
                  'Underhand Serve: The most basic and reliable serve for beginners. It involves holding the ball in one hand and striking it from beneath with a closed fist.',
                  'Overhand Serve: More powerful, but requires more practice. You toss the ball above your head and hit it with an open hand.'
                ]
              },
              {
                title: 'Passing (The "Bump")',
                description: 'The first contact on the ball, typically used to receive a serve or a hit from the opponent.',
                subComponents: [
                  'The goal is to direct the ball to a target (usually the setter) using your forearms, keeping your wrists together and arms straight.',
                  'Focus on getting your feet in the right position and using your legs to power the ball, not your arms.'
                ]
              },
              {
                title: 'Setting',
                description: 'The second contact, which prepares the ball for an attack.',
                subComponents: [
                  'Form a triangle with your hands and thumbs above your forehead.',
                  'Contact the ball with your fingertips and push it in the desired direction, using your legs and arms to control the trajectory.'
                ]
              },
              {
                title: 'Attacking (The "Spike")',
                description: 'The third contact, an attempt to score a point by hitting the ball into the opponent\'s court.',
                subComponents: [
                  'For beginners, practice self-toss and hit drills to get a feel for the arm swing and topspin.',
                  'Focus on the approach (the steps you take before jumping) and a full arm swing.'
                ]
              }
            ]
          }
        },
        advancedChampion: {
          title: 'The Advanced Player & Champion (Mastery and Strategy)',
          description: 'At this level, you\'ve mastered the skills and now focus on the mental and strategic aspects of the game.',
          keyConcepts: {
            title: 'Key Concepts to Master',
            components: [
              {
                title: 'Specialization',
                description: 'You may specialize in a specific position, such as setter, outside hitter, middle blocker, or libero. Each position has unique skills and responsibilities.'
              },
              {
                title: 'Advanced Serving',
                description: 'Develop a powerful and accurate jump serve or a highly effective jump float serve.'
              },
              {
                title: 'Offensive Systems',
                description: 'Understand and execute different offensive systems (e.g., 5-1, 6-2).'
              },
              {
                title: 'Defensive Formations',
                description: 'Learn different defensive formations (e.g., perimeter, rotational) and how to adjust them based on the opponent\'s attack.'
              },
              {
                title: 'Game IQ',
                description: 'Watch and analyze high-level volleyball. Learn to read the opponent\'s setter to anticipate the attack and read the opponent\'s serve to anticipate where the ball will go.'
              }
            ]
          },
          trainingForChampions: {
            title: 'Training for Champions',
            components: [
              {
                title: 'Match and Tournament Preparation',
                description: 'A week before a big match, focus on a specific game plan based on the opponent\'s tendencies. Practice error-free repetitions and instill confidence in your team.'
              },
              {
                title: 'Tactical Drills',
                description: 'Create drills that mimic game situations. For example, a drill that focuses on a specific serve-receive formation against a tough jump serve.'
              },
              {
                title: 'Physical Conditioning',
                description: 'A professional training routine includes a mix of strength training, plyometrics, and agility. The focus is on increasing vertical leap, explosive power, and court speed. Incorporate workouts that build muscle groups essential for the sport, such as calves, quads, and shoulders.'
              },
              {
                title: 'Mental Toughness',
                description: 'Learn to handle pressure and maintain focus during a match. Work on communication and teamwork, both on and off the court.'
              }
            ]
          },
          championMindset: {
            title: 'The Champion Mindset',
            components: [
              {
                title: 'Continuous Improvement',
                description: 'Even at the highest level, there is always room to improve. A champion is always learning and seeking feedback.'
              },
              {
                title: 'Resilience',
                description: 'Learn to recover from mistakes quickly and move on to the next point.'
              },
              {
                title: 'Leadership',
                description: 'A champion often takes on a leadership role, motivating teammates and communicating effectively.'
              }
            ],
            conclusion: 'The journey from a beginner to a champion is a long and rewarding process. By consistently practicing the fundamentals, building a strong physical and mental foundation, and always seeking to improve, you can reach your full potential in the sport of volleyball.'
          }
        }
      }
    },
    'powerlifting': {
      title: 'Powerlifting Training',
      description: 'Professional powerlifting coaching focusing on the three main lifts: squat, bench press, and deadlift.',
      image: 'https://sfhealthtech.com/cdn/shop/articles/A_Comprehensive_Guide_to_Powerlifting.jpg?v=1715158133',
      content: 'Our powerlifting program teaches proper technique for the three main lifts, builds strength progressively, and prepares athletes for powerlifting competitions.',
      detailedContent: {
        introduction: 'Powerlifting is a strength sport that consists of three lifts: the squat, bench press, and deadlift. The journey from a novice lifter to a competitive champion is a long and challenging one, but it is achievable with a strategic approach to training, nutrition, and recovery.',
        beginner: {
          title: 'The Beginner (Novice Lifter)',
          description: 'This is the most critical phase, where you build the foundational strength and master proper form. Your progress will be rapid, as your body adapts quickly to the new stimulus.',
          trainingPrinciples: {
            title: 'Training Principles',
            components: [
              {
                title: 'Frequency',
                description: 'Train 3-4 times per week. Many beginner programs use a full-body approach or an upper/lower split. You can squat and bench 2-3 times a week, and deadlift once a week.'
              },
              {
                title: 'Focus on the "Big Three"',
                description: 'Your primary focus should be on perfecting the squat, bench press, and deadlift. Accessory exercises are important for muscle growth and to support the main lifts, but they are secondary.'
              },
              {
                title: 'Progressive Overload',
                description: 'This is the key to all strength gains. Each workout, or each week, you should aim to add a small amount of weight to the bar. For the first 3-6 months, you should be able to add weight almost every week.'
              },
              {
                title: 'Keep it Simple',
                description: 'Don\'t overcomplicate your training. A simple linear progression program, where you add weight in small increments each session, is highly effective. Examples of popular beginner programs include Starting Strength or StrongLifts 5x5.'
              },
              {
                title: 'Learn Proper Form',
                description: 'This cannot be overstated. Incorrect form not only limits your strength potential but also significantly increases your risk of injury. Seek out a coach or experienced lifter to critique your form. Record your lifts and analyze them to ensure you are meeting competition standards (e.g., squatting to proper depth, pausing on the bench press).'
              }
            ]
          },
          sampleRoutine: {
            title: 'Sample Beginner Routine (3-day split)',
            description: 'Workout A: Squat, Bench Press, Barbell Row\nWorkout B: Deadlift, Overhead Press, Lat Pulldown\nWorkout C: Squat, Bench Press, Barbell Row\n\nFor each main lift, a common starting point is 3 sets of 5 reps.'
          },
          nutritionRecovery: {
            title: 'Nutrition & Recovery',
            components: [
              {
                title: 'Caloric Surplus',
                description: 'To build muscle and strength, you need to eat more calories than you burn. Don\'t be afraid to gain some weight during this phase.'
              },
              {
                title: 'Protein',
                description: 'Prioritize protein intake to support muscle repair and growth. Aim for 1.6-2.2 grams of protein per kilogram of body weight daily.'
              },
              {
                title: 'Carbohydrates',
                description: 'Carbs are your body\'s primary fuel for high-intensity training. Don\'t skip them.'
              },
              {
                title: 'Hydration',
                description: 'Drink plenty of water throughout the day.'
              },
              {
                title: 'Sleep',
                description: 'Get 7-9 hours of quality sleep per night. This is when your body recovers and builds muscle.'
              }
            ]
          }
        },
        advancedChampion: {
          title: 'The Advanced Lifter & Champion',
          description: 'At this stage, gains are incremental and require meticulous planning and a high level of dedication. Training is no longer about simply adding weight each week; it\'s a strategic process.',
          trainingPrinciples: {
            title: 'Training Principles',
            components: [
              {
                title: 'Advanced Periodization',
                description: 'You will use more complex periodization schemes like the Conjugate Method (popularized by Westside Barbell) or a block periodization model.',
                subComponents: [
                  'Conjugate Method: Involves rotating exercises frequently to train different strength qualities. It includes max effort work (heavy singles or doubles), dynamic effort work (lifting submaximal weights with speed), and repetition work (accessory exercises for hypertrophy).',
                  'Block Periodization: Divides training into distinct blocks (e.g., hypertrophy block, strength block, and a peaking block for a competition).'
                ]
              },
              {
                title: 'Specialized Training Techniques',
                description: 'Incorporate advanced techniques to break through plateaus and maximize gains.',
                subComponents: [
                  'Accommodating Resistance: Use bands and chains to match resistance to your strength curve.',
                  'Velocity-Based Training (VBT): Use a device to measure bar speed to guide your training and ensure you are lifting with maximal intent.',
                  'Cluster Sets: Break a set into smaller mini-sets with short rests to maintain high power output.',
                  'Pause Lifts: Use a pause at the bottom of the squat, bench, or deadlift to build strength in specific ranges of motion.'
                ]
              }
            ]
          },
          nutritionRecovery: {
            title: 'Nutrition & Recovery',
            components: [
              {
                title: 'Meticulous Diet',
                description: 'Your diet will be highly refined and potentially cyclical to align with your training phases. You may need to gain or cut weight to make a specific weight class for a competition.'
              },
              {
                title: 'Supplementation',
                description: 'Consider a limited number of evidence-based supplements that can aid performance and recovery, such as creatine and protein powder.'
              },
              {
                title: 'Strategic Peaking',
                description: 'Leading up to a competition, your training will enter a "peaking" phase where you decrease volume and increase intensity to maximize your performance on the platform. This is a delicate balance of being recovered and primed for a max effort.'
              },
              {
                title: 'Mental Fortitude',
                description: 'As a champion, the mental game is as important as the physical one. You must have the discipline to follow your plan, the confidence to attempt a personal record on the platform, and the resilience to bounce back from setbacks.'
              }
            ]
          },
          conclusion: 'The path from beginner to champion is a marathon, not a sprint. Consistency, patience, and a willingness to learn and adapt are the hallmarks of a successful powerlifter.'
        }
      }
    },
    'sports-infrastructure': {
      title: 'Sports Infrastructure Developer',
      description: 'Comprehensive sports infrastructure development services including facility design, construction, and equipment installation.',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFkbWludG9ufGVufDB8fDB8fHww&fm=jpg&q=60&w=3000',
      content: 'Our sports infrastructure development services cover everything from initial planning and design to construction and equipment installation. We create world-class sports facilities that meet international standards.',
      detailedContent: {
        introduction: 'We sports infrastructure developer company is that specializes in the design, construction, and management of sports facilities. These facilities can range from small, local sports grounds to large, international-standard stadiums and complexes. Our services often include everything from initial consultation and design to the manufacturing of materials, installation, and ongoing maintenance.',
        // services: {
        //   title: 'Our Services',
        //   description: 'Start with Consultancy for Sports Infra development and maintenance.',
        //   components: [
        //     {
        //       title: 'Design and Planning',
        //       description: 'Creating comprehensive plans, often with CAD designs, that outline the layout, surface materials, lighting, and other details.',
        //       subComponents: [
        //         'Conducting feasibility studies and providing consulting services to ensure projects are viable and meet client needs.'
        //       ]
        //     },
        //     {
        //       title: 'Construction and Installation',
        //       description: 'Building the physical infrastructure, including civil works, drainage systems, and foundations.',
        //       subComponents: [
        //         'Installing specialized surfaces like artificial turf for football and hockey, synthetic athletic tracks, and various types of sports flooring (e.g., acrylic, polyurethane, wood).',
        //         'Setting up supporting structures such as fencing, lighting, and seating.'
        //       ]
        //     },
        //     {
        //       title: 'Product Manufacturing and Supply',
        //       description: 'We also manufacture their own sports surfaces and materials, ensuring quality control from the raw material stage to the finished product.',
        //       subComponents: [
        //         'We also supply a range of sports equipment, including nets, goals, and other accessories.'
        //       ]
        //     },
        //     {
        //       title: 'Maintenance and Refurbishment',
        //       description: 'Providing dedicated maintenance services to ensure the longevity and performance of sports surfaces and facilities.',
        //       subComponents: [
        //         'Offering pitch replacement or refurbishment services for existing synthetic turfs.'
        //       ]
        //     }
        //   ]
        // },
        director: {
          title: 'Chitra Parihar - Director',
          description: 'I am Director Chief Badminton Coach and Sports Psychologist of Ask Me Sports Allianz. I am also member of Rajasthan Badminton Association. I am senior management & Coach positions in Rajasthan Sport Association.',
          experience: {
            title: 'Professional Experience',
            components: [
              {
                title: 'Government Sports Strategy',
                description: 'I was Head of Sports Strategy, Sports Recruitment & Development of Sports in Government and was part of the executive team to transform the sports to an international level.'
              },
              {
                title: 'International Badminton Player',
                description: 'I was professional Badminton player, who played in UK for 2 years as professional badminton and was also the participated in London Open, Along with many international tournaments & Circuit championship.'
              },
              {
                title: 'International Coaching Experience',
                description: 'I also holds the back ground of international badminton coach with coaching ability and coaching experience in countries like China, & Mauritius. With new contract coming for Malaysia.'
              }
            ]
          },
          education: {
            title: 'Educational Background',
            description: 'My educational qualification is MBA & Sports Management degree background from New Port University California.'
          },
          currentProjects: {
            title: 'Current Projects',
            description: 'I am sports converter and have taken up Badminton & nearly all sports with passion.',
            components: [
              {
                title: 'Sports Academies',
                description: 'I have total Two Badminton Sports Academies in Jaipur and running successfully which includes multi sports like Tennis, Table tennis, Archery, Fitness Centre Swimming Etc.'
              }
            ]
          },
          futureVision: {
            title: 'Future Vision',
            description: 'To take badminton to new height with exchange coaching program with Malaysia & Indonesia badminton academies. Were the player and coaches also have the better nourishment and use of latest techniques which includes playing and fitness of them. My experience of badminton can also be helpful to foreign academies.'
          },
          qualifications: {
            title: 'Professional Qualifications',
            components: [
              'International Badminton Player and International Coach.',
              'BWF certified Level- 1 Coach',
              'Only Coach in Rajasthan to do Advance Coaches Program conducted by Badminton Association of India in 2024.',
              'Sports Psychologist Course: Develop the Mindset of Champion in 2021'
            ]
          }
        }
      }
    }
  };

  const sport = sportsData[sportId];


  if (!sport) {
    return (
      <div className="sports-page">
        <div className="container">
          <h1 className="sport-title">Sport Not Found</h1>
          <p className="sport-description">The sport you are looking for does not exist.</p>
        </div>
      </div>
    );
  }

  const handleLearnMore = (serviceId) => {
    navigate(`/service/${serviceId}`);
  };

  return (
    <div className="sports-page">
      <section className="sport-hero" style={{ backgroundImage: `url(${sport.image})` }}>
        <div className="sport-overlay"></div>
        <div className="container sport-hero-content">
          <h1 className="sport-title">{sport.title}</h1>
          <p className="sport-description">{sport.description}</p>
        </div>
      </section>


      <section className="sport-content-section">
        <div className="container">
          <div className="sport-content">
            <p className="sport-content-text">{sport.content}</p>

            {sport.detailedContent && (
              <div className="detailed-content">
                <div className="introduction-section">
                  <p className="introduction-text">{sport.detailedContent.introduction}</p>
                </div>

                {/* Sports Fitness Content */}
                {sport.detailedContent.keyComponents && (
                  <div className="key-components-section">
                    <h2 className="section-title">Key Components of Sports Fitness</h2>
                    <p className="section-description">Sports fitness encompasses a comprehensive approach that targets several key areas:</p>

                    <div className="components-grid">
                      {sport.detailedContent.keyComponents && sport.detailedContent.keyComponents.map((component, index) => (
                        <div key={index} className="component-card">
                          <h3 className="component-title">{component.title}</h3>
                          <p className="component-description">{component.description}</p>
                          {component.items && (
                            <ul className="component-items">
                              {component.items.map((item, itemIndex) => (
                                <li key={itemIndex} className="component-item">{item}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                  <section className="flooring-products-section">
        <div className="container">
          <h2 className="section-title">Sports Flooring Products</h2>
          <div className="products-grid">
            {/* Volleyball Court Construction */}
            <div className="product-card volleyball">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1612872087720-bb876e2e67d1?w=100&h=100&fit=crop&crop=center" alt="Volleyball" />
                </div>
                <h3 className="product-title">Volleyball Court Construction</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  ASK ME SPORTS ALLIANCE are Volleyball Court Builders in India. We provide flooring options for both Indoor and Outdoor Courts.
                </p>
                <div className="product-specs">
                  <h4 className="specs-title">Court Specifications:</h4>
                  <ul className="specs-list">
                    <li>18 meters long and 9 meters wide</li>
                    <li>Net height: 2.43m (men) / 2.24m (women)</li>
                    <li>Divided into two 9m x 9m halves</li>
                  </ul>
                </div>
                <div className="flooring-options">
                  <h4 className="options-title">Available Surfaces:</h4>
                  <div className="options-grid">
                    <span className="option-item">Air-Cush Wooden Flooring</span>
                    <span className="option-item">Outdoor Synthetic Surface</span>
                    <span className="option-item">Indoor PVC Vinyl Flooring</span>
                    <span className="option-item">Rubber Flooring</span>
                    <span className="option-item">PP Tiles</span>
                    <span className="option-item">Artificial Grass</span>
                    <span className="option-item">Natural</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Cricket Pitch Construction */}
            <div className="product-card cricket">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=100&h=100&fit=crop&crop=center" alt="Cricket" />
                </div>
                <h3 className="product-title">Cricket Pitch Construction</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  Cricket Pitch is a natural product that needs to be handled with great care. We carefully assess what's required, adapting our construction techniques to deliver high-performance pitches.
                </p>
                <div className="construction-steps">
                  <h4 className="steps-title">Construction Process:</h4>
                  <div className="steps-list">
                    <div className="step-item">
                      <span className="step-number">1</span>
                      <span className="step-text">Excavate for Pitch Formation</span>
                    </div>
                    <div className="step-item">
                      <span className="step-number">2</span>
                      <span className="step-text">Levelling and Consolidation</span>
                    </div>
                    <div className="step-item">
                      <span className="step-number">3</span>
                      <span className="step-text">Prepare Final Surface and Seed</span>
                    </div>
                  </div>
                </div>
                <div className="pitch-types">
                  <h4 className="types-title">Pitch Types:</h4>
                  <div className="types-grid">
                    <span className="type-item">Natural Grass</span>
                    <span className="type-item">Artificial Turf</span>
                    <span className="type-item">Hybrid Systems</span>
                  </div>
                </div>
              </div>
            </div>

            {/* PP Interlocking Tiles */}
            <div className="product-card pp-tiles">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://gallantsports.in/wp-content/uploads/2025/01/Sports-Interlocking-Tiles_side-image.jpg" alt="PP Tiles" />
                </div>
                <h3 className="product-title">PP Interlocking Tiles</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  Polypropylene Interlocking Suspended Modular Tiles - New Age Sports flooring, revolutionary, designed to eliminate traditional flooring cons, suitable for both indoor and outdoor applications.
                </p>
                <div className="features-grid">
                  <div className="feature-column">
                    <h4 className="features-title">Key Features:</h4>
                    <ul className="features-list">
                      <li>Environmentally friendly recyclable PP-composite</li>
                      <li>UV and Color stabilized for all weather</li>
                      <li>FDA approved - No emissions (No PVC)</li>
                      <li>Ergonomic - good for joints and backs</li>
                      <li>Correct bounce across the whole court</li>
                      <li>Extremely durable</li>
                      <li>Excellent drainage capability</li>
                      <li>Long warranty of 8 years</li>
                    </ul>
                  </div>
                  <div className="feature-column">
                    <h4 className="features-title">Additional Benefits:</h4>
                    <ul className="features-list">
                      <li>Expansion strips for longer lifespan</li>
                      <li>100% recyclable raw materials</li>
                      <li>Multiple colors available</li>
                      <li>Easy to install and uninstall</li>
                      <li>Tiles can be moved easily</li>
                      <li>Very low maintenance</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* EPDM Flooring */}
            <div className="product-card epdm">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://amazingfloors.in/wp-content/uploads/2025/01/Epdm-Flooring-7-1.jpg" alt="EPDM Flooring" />
                </div>
                <h3 className="product-title">EPDM Flooring</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  EPDM (ethylene propylene diene monomer) rubber is synthetic and is used for various purposes including playground surfaces, Jogging Track, and sports flooring. It is safe and non-toxic, making it great for children's playgrounds.
                </p>
                <div className="epdm-features">
                  <h4 className="epdm-title">Main Features:</h4>
                  <div className="epdm-grid">
                    <span className="epdm-feature">Resistance to UV exposure</span>
                    <span className="epdm-feature">Resistance to extreme weather</span>
                    <span className="epdm-feature">Stable in low and high temperatures</span>
                    <span className="epdm-feature">Waterproof and effective drainage</span>
                    <span className="epdm-feature">Low electrical conductivity</span>
                    <span className="epdm-feature">Won't become brittle over time</span>
                    <span className="epdm-feature">Cushioning to guard against falls</span>
                    <span className="epdm-feature">Absorbs noise</span>
                    <span className="epdm-feature">Multiple stylish color choices</span>
                    <span className="epdm-feature">Easy to clean</span>
                    <span className="epdm-feature">Cost-effective material</span>
                    <span className="epdm-feature">Eco-friendly, often recycled materials</span>
                  </div>
                </div>
              </div>
            </div>

            {/* EVA Kabaddi Mat */}
            <div className="product-card eva-mat">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=100&h=100&fit=crop&crop=center" alt="EVA Mat" />
                </div>
                <h3 className="product-title">EVA Kabaddi Mat</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  Made of EVA close-cell foam, with good anti-slippery patterns, durable, superior shock absorption, easy to clean and water resistant, high standard for kabaddi to avoid injuries while playing.
                </p>
                <div className="eva-advantages">
                  <h4 className="eva-title">Product Advantages:</h4>
                  <ul className="eva-list">
                    <li>Easy to assemble, anti slippery, stain resistant</li>
                    <li>Border strips water proof, tough top surface</li>
                    <li>Color choices available as per requirement</li>
                    <li>Made from non-toxic Material, durable, light weight</li>
                    <li>High density EVA foam</li>
                    <li>All tiles are waterproof and easily cleanable</li>
                    <li>Provides cushion to hard floor surfaces</li>
                    <li>Life: 8 to 10 Years</li>
                  </ul>
                </div>
                <div className="usage-applications">
                  <h4 className="usage-title">Usage Applications:</h4>
                  <div className="usage-grid">
                    <span className="usage-item">Kabaddi</span>
                    <span className="usage-item">Martial Arts</span>
                    <span className="usage-item">Karate</span>
                    <span className="usage-item">Taekwondo</span>
                    <span className="usage-item">Jiu Jitsu</span>
                    <span className="usage-item">Wrestling</span>
                    <span className="usage-item">Kindergarten</span>
                    <span className="usage-item">General Exercise</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Artificial Turf Cricket */}
            <div className="product-card artificial-turf">
              <div className="product-header">
                <div className="product-icon">
                  <img src="https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?w=100&h=100&fit=crop&crop=center" alt="Artificial Turf" />
                </div>
                <h3 className="product-title">Artificial Turf Cricket</h3>
              </div>
              <div className="product-content">
                <p className="product-description">
                  ELITE INTERNATIONAL offers a true surface with realistic turn and bounce to help take your game to the next level. Perfect for all-weather cricket surfaces when natural wickets are not feasible.
                </p>
                <div className="turf-benefits">
                  <h4 className="turf-title">Key Benefits:</h4>
                  <ul className="turf-list">
                    <li>Realistic turn and bounce characteristics</li>
                    <li>All-weather playing surface</li>
                    <li>Continuous play capability</li>
                    <li>Ideal for training and skills development</li>
                    <li>Perfect for schools and cricket grounds</li>
                    <li>Flat and free-draining surface</li>
                    <li>Unpredictable weather resistant</li>
                  </ul>
                </div>
                <div className="turf-applications">
                  <h4 className="applications-title">Applications:</h4>
                  <div className="applications-grid">
                    <span className="application-item">Match Play</span>
                    <span className="application-item">Practice Nets</span>
                    <span className="application-item">Indoor Training</span>
                    <span className="application-item">Bowlers Run-ups</span>
                    <span className="application-item">Batting Cages</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

                {sport.detailedContent.improvementMethods && (
                  <div className="improvement-methods-section">
                    <h2 className="section-title">How Athletes Improve Sports Fitness</h2>
                    <p className="section-description">Athletes use a variety of methods and strategies to enhance their sports fitness:</p>

                    <div className="methods-grid">
                      {sport.detailedContent.improvementMethods && sport.detailedContent.improvementMethods.map((method, index) => (
                        <div key={index} className="method-card">
                          <h3 className="method-title">{method.title}</h3>
                          <p className="method-description">{method.description}</p>
                          {method.items && (
                            <ul className="method-items">
                              {method.items.map((item, itemIndex) => (
                                <li key={itemIndex} className="method-item">{item}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Badminton Content */}
                {sport.detailedContent.pathToChampion && (
                  <div className="path-to-champion-section">
                    <h2 className="section-title">{sport.detailedContent.pathToChampion.title}</h2>
                    <p className="section-description">{sport.detailedContent.pathToChampion.description}</p>

                    <div className="champion-content">
                      <div className="training-schedule">
                        <h3 className="subsection-title">{sport.detailedContent.pathToChampion.trainingSchedule.title}</h3>
                        <p className="subsection-description">{sport.detailedContent.pathToChampion.trainingSchedule.description}</p>

                        <div className="training-grid">
                          <div className="training-card">
                            <h4 className="training-title">{sport.detailedContent.pathToChampion.trainingSchedule.onCourtTraining.title}</h4>
                            <p className="training-description">{sport.detailedContent.pathToChampion.trainingSchedule.onCourtTraining.description}</p>
                          </div>

                          <div className="training-card">
                            <h4 className="training-title">{sport.detailedContent.pathToChampion.trainingSchedule.offCourtTraining.title}</h4>
                            <p className="training-description">{sport.detailedContent.pathToChampion.trainingSchedule.offCourtTraining.description}</p>
                            <ul className="training-items">
                              {sport.detailedContent.pathToChampion?.trainingSchedule?.offCourtTraining?.components && sport.detailedContent.pathToChampion.trainingSchedule.offCourtTraining.components.map((component, index) => (
                                <li key={index} className="training-item">
                                  <strong>{component.title}:</strong> {component.description}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Boxing Content */}
                {sport.detailedContent.aspiringChampion && (
                  <div className="aspiring-champion-section">
                    <h2 className="section-title">{sport.detailedContent.aspiringChampion.title}</h2>
                    <p className="section-description">{sport.detailedContent.aspiringChampion.description}</p>

                    <div className="boxing-content">
                      <div className="physical-conditioning">
                        <h3 className="subsection-title">{sport.detailedContent.aspiringChampion.physicalConditioning.title}</h3>
                        <p className="subsection-description">{sport.detailedContent.aspiringChampion.physicalConditioning.description}</p>

                        <div className="conditioning-grid">
                          {sport.detailedContent.aspiringChampion?.physicalConditioning?.components && sport.detailedContent.aspiringChampion.physicalConditioning.components.map((component, index) => (
                            <div key={index} className="conditioning-card">
                              <h4 className="conditioning-title">{component.title}</h4>
                              <p className="conditioning-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="advanced-techniques">
                        <h3 className="subsection-title">{sport.detailedContent.aspiringChampion.advancedTechniques.title}</h3>
                        <div className="techniques-grid">
                          {sport.detailedContent.aspiringChampion?.advancedTechniques?.components && sport.detailedContent.aspiringChampion.advancedTechniques.components.map((technique, index) => (
                            <div key={index} className="technique-card">
                              <h4 className="technique-title">{technique.title}</h4>
                              <p className="technique-description">{technique.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Shooting Content */}
                {sport.detailedContent.chooseDiscipline && (
                  <div className="choose-discipline-section">
                    <h2 className="section-title">{sport.detailedContent.chooseDiscipline.title}</h2>
                    <p className="section-description">{sport.detailedContent.chooseDiscipline.description}</p>
                  </div>
                )}

                {sport.detailedContent.advancedPhase && (
                  <div className="advanced-phase-section">
                    <h2 className="section-title">{sport.detailedContent.advancedPhase.title}</h2>
                    <p className="section-description">{sport.detailedContent.advancedPhase.description}</p>

                    <div className="advanced-grid">
                      {sport.detailedContent.advancedPhase?.components && sport.detailedContent.advancedPhase.components.map((component, index) => (
                        <div key={index} className="advanced-card">
                          <h3 className="advanced-title">{component.title}</h3>
                          <p className="advanced-description">{component.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}


                {sport.detailedContent.championPhase && (
                  <div className="champion-phase-section">
                    <h2 className="section-title">{sport.detailedContent.championPhase.title}</h2>
                    <p className="section-description">{sport.detailedContent.championPhase.description}</p>

                    <div className="champion-grid">
                      {sport.detailedContent.championPhase?.components && sport.detailedContent.championPhase.components.map((component, index) => (
                        <div key={index} className="champion-card">
                          <h3 className="champion-title">{component.title}</h3>
                          <p className="champion-description">{component.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Conclusion */}
                {/* Athletics Content */}
                {sport.detailedContent.championPath && (
                  <div className="champion-path-section">
                    <h2 className="section-title">{sport.detailedContent.championPath.title}</h2>
                    <p className="section-description">{sport.detailedContent.championPath.description}</p>

                    {sport.detailedContent.championPath.trainingPrinciples && (
                      <div className="training-principles-section">
                        <h3 className="subsection-title">{sport.detailedContent.championPath.trainingPrinciples.title}</h3>
                        <p className="subsection-description">{sport.detailedContent.championPath.trainingPrinciples.description}</p>

                        <div className="principles-grid">
                          {sport.detailedContent.championPath?.trainingPrinciples?.components && sport.detailedContent.championPath.trainingPrinciples.components.map((component, index) => (
                            <div key={index} className="principle-card">
                              <h4 className="principle-title">{component.title}</h4>
                              <p className="principle-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {sport.detailedContent.championPath.mindset && (
                      <div className="mindset-section">
                        <h3 className="subsection-title">{sport.detailedContent.championPath.mindset.title}</h3>

                        <div className="mindset-grid">
                          {sport.detailedContent.championPath?.mindset?.components && sport.detailedContent.championPath.mindset.components.map((component, index) => (
                            <div key={index} className="mindset-card">
                              <h4 className="mindset-title">{component.title}</h4>
                              <p className="mindset-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Weightlifting Content */}
                {sport.detailedContent.layingFoundation && (
                  <div className="laying-foundation-section">
                    <h2 className="section-title">{sport.detailedContent.layingFoundation.title}</h2>
                    <p className="section-description">{sport.detailedContent.layingFoundation.description}</p>

                    <div className="foundation-grid">
                      {sport.detailedContent.layingFoundation?.components && sport.detailedContent.layingFoundation.components.map((component, index) => (
                        <div key={index} className="foundation-card">
                          <h3 className="foundation-title">{component.title}</h3>
                          <p className="foundation-description">{component.description}</p>
                          {component.subComponents && (
                            <ul className="foundation-list">
                              {component.subComponents.map((subComponent, subIndex) => (
                                <li key={subIndex} className="foundation-item">{subComponent}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {sport.detailedContent.champion && (
                  <div className="champion-section">
                    <h2 className="section-title">{sport.detailedContent.champion.title}</h2>
                    <p className="section-description">{sport.detailedContent.champion.description}</p>

                    <div className="champion-grid">
                      {sport.detailedContent.champion?.components && sport.detailedContent.champion.components.map((component, index) => (
                        <div key={index} className="champion-card">
                          <h3 className="champion-title">{component.title}</h3>
                          <p className="champion-description">{component.description}</p>
                          {component.subComponents && (
                            <ul className="champion-list">
                              {component.subComponents.map((subComponent, subIndex) => (
                                <li key={subIndex} className="champion-item">{subComponent}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Cricket (Women) Content */}
                {sport.detailedContent.learnBasics && (
                  <div className="learn-basics-section">
                    <h2 className="section-title">{sport.detailedContent.learnBasics.title}</h2>

                    <div className="basics-grid">
                      {sport.detailedContent.learnBasics?.components && sport.detailedContent.learnBasics.components.map((component, index) => (
                        <div key={index} className="basics-card">
                          <h3 className="basics-title">{component.title}</h3>
                          <p className="basics-description">{component.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {sport.detailedContent.developSkills && (
                  <div className="develop-skills-section">
                    <h2 className="section-title">{sport.detailedContent.developSkills.title}</h2>

                    <div className="skills-grid">
                      {sport.detailedContent.developSkills?.components && sport.detailedContent.developSkills.components.map((component, index) => (
                        <div key={index} className="skills-card">
                          <h3 className="skills-title">{component.title}</h3>
                          <p className="skills-description">{component.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {sport.detailedContent.specializedTraining && (
                  <div className="specialized-training-section">
                    <h2 className="section-title">{sport.detailedContent.specializedTraining.title}</h2>
                    <p className="section-description">{sport.detailedContent.specializedTraining.description}</p>

                    <div className="training-grid">
                      {sport.detailedContent.specializedTraining?.components && sport.detailedContent.specializedTraining.components.map((component, index) => (
                        <div key={index} className="training-card">
                          <h3 className="training-title">{component.title}</h3>
                          <p className="training-description">{component.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {sport.detailedContent.champion && sport.detailedContent.champion.pathway && (
                  <div className="pathway-section">
                    <h2 className="section-title">{sport.detailedContent.champion.pathway.title}</h2>
                    <p className="section-description">{sport.detailedContent.champion.pathway.description}</p>

                    <div className="pathway-grid">
                      {sport.detailedContent.champion?.pathway?.components && sport.detailedContent.champion.pathway.components.map((component, index) => (
                        <div key={index} className="pathway-card">
                          <h3 className="pathway-title">{component.title}</h3>
                          <p className="pathway-description">{component.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {sport.detailedContent.champion && sport.detailedContent.champion.professionalTraining && (
                  <div className="professional-training-section">
                    <h2 className="section-title">{sport.detailedContent.champion.professionalTraining.title}</h2>
                    <p className="section-description">{sport.detailedContent.champion.professionalTraining.description}</p>

                    <div className="professional-grid">
                      {sport.detailedContent.champion?.professionalTraining?.components && sport.detailedContent.champion.professionalTraining.components.map((component, index) => (
                        <div key={index} className="professional-card">
                          <h3 className="professional-title">{component.title}</h3>
                          <p className="professional-description">{component.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {sport.detailedContent.champion && sport.detailedContent.champion.continuousImprovement && (
                  <div className="continuous-improvement-section">
                    <h2 className="section-title">{sport.detailedContent.champion.continuousImprovement.title}</h2>
                    <p className="section-description">{sport.detailedContent.champion.continuousImprovement.description}</p>
                    <p className="conclusion-text">{sport.detailedContent.champion.continuousImprovement.conclusion}</p>
                  </div>
                )}

                {/* Tennis Content */}
                {sport.detailedContent.technicalStrategic && (
                  <div className="technical-strategic-section">
                    <h2 className="section-title">{sport.detailedContent.technicalStrategic.title}</h2>

                    <div className="technical-grid">
                      {sport.detailedContent.technicalStrategic?.components && sport.detailedContent.technicalStrategic.components.map((component, index) => (
                        <div key={index} className="technical-card">
                          <h3 className="technical-title">{component.title}</h3>
                          <p className="technical-description">{component.description}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {sport.detailedContent.physicalMental && (
                  <div className="physical-mental-section">
                    <h2 className="section-title">{sport.detailedContent.physicalMental.title}</h2>

                    <div className="physical-grid">
                      {sport.detailedContent.physicalMental?.components && sport.detailedContent.physicalMental.components.map((component, index) => (
                        <div key={index} className="physical-card">
                          <h3 className="physical-title">{component.title}</h3>
                          <p className="physical-description">{component.description}</p>
                          {component.subComponents && (
                            <ul className="physical-list">
                              {component.subComponents.map((subComponent, subIndex) => (
                                <li key={subIndex} className="physical-item">{subComponent}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {sport.detailedContent.champion && sport.detailedContent.champion.roadToProfessionalism && (
                  <div className="road-to-professionalism-section">
                    <h2 className="section-title">{sport.detailedContent.champion.roadToProfessionalism.title}</h2>

                    <div className="road-grid">
                      {sport.detailedContent.champion?.roadToProfessionalism?.components && sport.detailedContent.champion.roadToProfessionalism.components.map((component, index) => (
                        <div key={index} className="road-card">
                          <h3 className="road-title">{component.title}</h3>
                          <p className="road-description">{component.description}</p>
                        </div>
                      ))}
                    </div>

                    {sport.detailedContent.champion.roadToProfessionalism.conclusion && (
                      <div className="tennis-conclusion-section">
                        <p className="tennis-conclusion-text">{sport.detailedContent.champion.roadToProfessionalism.conclusion}</p>
                      </div>
                    )}
                  </div>
                )}

                {/* Volleyball Content */}
                {sport.detailedContent.beginner && (
                  <div className="beginner-section">
                    <h2 className="section-title">{sport.detailedContent.beginner.title}</h2>
                    <p className="section-description">{sport.detailedContent.beginner.description}</p>

                    {sport.detailedContent.beginner.keySkills && (
                      <div className="key-skills-section">
                        <h3 className="subsection-title">{sport.detailedContent.beginner.keySkills.title}</h3>

                        <div className="skills-grid">
                          {sport.detailedContent.beginner?.keySkills?.components && sport.detailedContent.beginner.keySkills.components.map((component, index) => (
                            <div key={index} className="skill-card">
                              <h4 className="skill-title">{component.title}</h4>
                              <p className="skill-description">{component.description}</p>
                              {component.subComponents && (
                                <ul className="skill-list">
                                  {component.subComponents.map((subComponent, subIndex) => (
                                    <li key={subIndex} className="skill-item">{subComponent}</li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {sport.detailedContent.advancedChampion && (
                  <div className="advanced-champion-section">
                    <h2 className="section-title">{sport.detailedContent.advancedChampion.title}</h2>
                    <p className="section-description">{sport.detailedContent.advancedChampion.description}</p>

                    {sport.detailedContent.advancedChampion.keyConcepts && (
                      <div className="key-concepts-section">
                        <h3 className="subsection-title">{sport.detailedContent.advancedChampion.keyConcepts.title}</h3>

                        <div className="concepts-grid">
                          {sport.detailedContent.advancedChampion?.keyConcepts?.components && sport.detailedContent.advancedChampion.keyConcepts.components.map((component, index) => (
                            <div key={index} className="concept-card">
                              <h4 className="concept-title">{component.title}</h4>
                              <p className="concept-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {sport.detailedContent.advancedChampion.trainingForChampions && (
                      <div className="training-champions-section">
                        <h3 className="subsection-title">{sport.detailedContent.advancedChampion.trainingForChampions.title}</h3>

                        <div className="training-grid">
                          {sport.detailedContent.advancedChampion?.trainingForChampions?.components && sport.detailedContent.advancedChampion.trainingForChampions.components.map((component, index) => (
                            <div key={index} className="training-card">
                              <h4 className="training-title">{component.title}</h4>
                              <p className="training-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {sport.detailedContent.advancedChampion.championMindset && (
                      <div className="champion-mindset-section">
                        <h3 className="subsection-title">{sport.detailedContent.advancedChampion.championMindset.title}</h3>

                        <div className="mindset-grid">
                          {sport.detailedContent.advancedChampion?.championMindset?.components && sport.detailedContent.advancedChampion.championMindset.components.map((component, index) => (
                            <div key={index} className="mindset-card">
                              <h4 className="mindset-title">{component.title}</h4>
                              <p className="mindset-description">{component.description}</p>
                            </div>
                          ))}
                        </div>

                        {sport.detailedContent.advancedChampion.championMindset.conclusion && (
                          <div className="volleyball-conclusion-section">
                            <p className="volleyball-conclusion-text">{sport.detailedContent.advancedChampion.championMindset.conclusion}</p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Powerlifting Content */}
                {sport.detailedContent.beginner && (
                  <div className="beginner-section">
                    <h2 className="section-title">{sport.detailedContent.beginner.title}</h2>
                    <p className="section-description">{sport.detailedContent.beginner.description}</p>

                    {sport.detailedContent.beginner.trainingPrinciples && (
                      <div className="training-principles-section">
                        <h3 className="subsection-title">{sport.detailedContent.beginner.trainingPrinciples.title}</h3>

                        <div className="principles-grid">
                          {sport.detailedContent.beginner?.trainingPrinciples?.components && sport.detailedContent.beginner.trainingPrinciples.components.map((component, index) => (
                            <div key={index} className="principle-card">
                              <h4 className="principle-title">{component.title}</h4>
                              <p className="principle-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {sport.detailedContent.beginner.sampleRoutine && (
                      <div className="sample-routine-section">
                        <h3 className="subsection-title">{sport.detailedContent.beginner.sampleRoutine.title}</h3>
                        <p className="routine-description">{sport.detailedContent.beginner.sampleRoutine.description}</p>
                      </div>
                    )}

                    {sport.detailedContent.beginner.nutritionRecovery && (
                      <div className="nutrition-recovery-section">
                        <h3 className="subsection-title">{sport.detailedContent.beginner.nutritionRecovery.title}</h3>

                        <div className="nutrition-grid">
                          {sport.detailedContent.beginner?.nutritionRecovery?.components && sport.detailedContent.beginner.nutritionRecovery.components.map((component, index) => (
                            <div key={index} className="nutrition-card">
                              <h4 className="nutrition-title">{component.title}</h4>
                              <p className="nutrition-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {sport.detailedContent.advancedChampion && (
                  <div className="advanced-champion-section">
                    <h2 className="section-title">{sport.detailedContent.advancedChampion.title}</h2>
                    <p className="section-description">{sport.detailedContent.advancedChampion.description}</p>

                    {sport.detailedContent.advancedChampion.trainingPrinciples && (
                      <div className="advanced-training-section">
                        <h3 className="subsection-title">{sport.detailedContent.advancedChampion.trainingPrinciples.title}</h3>

                        <div className="advanced-grid">
                          {sport.detailedContent.advancedChampion.trainingPrinciples.components.map((component, index) => (
                            <div key={index} className="advanced-card">
                              <h4 className="advanced-title">{component.title}</h4>
                              <p className="advanced-description">{component.description}</p>
                              {component.subComponents && (
                                <ul className="advanced-list">
                                  {component.subComponents.map((subComponent, subIndex) => (
                                    <li key={subIndex} className="advanced-item">{subComponent}</li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {sport.detailedContent.advancedChampion.nutritionRecovery && (
                      <div className="advanced-nutrition-section">
                        <h3 className="subsection-title">{sport.detailedContent.advancedChampion.nutritionRecovery.title}</h3>

                        <div className="advanced-nutrition-grid">
                          {sport.detailedContent.advancedChampion.nutritionRecovery.components.map((component, index) => (
                            <div key={index} className="advanced-nutrition-card">
                              <h4 className="advanced-nutrition-title">{component.title}</h4>
                              <p className="advanced-nutrition-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {sport.detailedContent.advancedChampion.conclusion && (
                      <div className="powerlifting-conclusion-section">
                        <p className="powerlifting-conclusion-text">{sport.detailedContent.advancedChampion.conclusion}</p>
                      </div>
                    )}
                  </div>
                )}

                {/* Sports Infrastructure Developer Content */}
                {sport.detailedContent.services && (
                  <div className="services-section">
                    <h2 className="section-title">{sport.detailedContent.services.title}</h2>
                    <p className="section-description">{sport.detailedContent.services.description}</p>

                    <div className="services-grid">
                      {sport.detailedContent.services.components.map((component, index) => (
                        <div key={index} className="service-card">
                          <h3 className="service-title">{component.title}</h3>
                          <p className="service-description">{component.description}</p>
                          {component.subComponents && (
                            <ul className="service-list">
                              {component.subComponents.map((subComponent, subIndex) => (
                                <li key={subIndex} className="service-item">{subComponent}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {sport.detailedContent.director && (
                  <div className="director-section">
                    <h2 className="section-title">{sport.detailedContent.director.title}</h2>
                    <p className="section-description">{sport.detailedContent.director.description}</p>

                    {sport.detailedContent.director.experience && (
                      <div className="experience-section">
                        <h3 className="subsection-title">{sport.detailedContent.director.experience.title}</h3>

                        <div className="experience-grid">
                          {sport.detailedContent.director.experience.components.map((component, index) => (
                            <div key={index} className="experience-card">
                              <h4 className="experience-title">{component.title}</h4>
                              <p className="experience-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {sport.detailedContent.director.education && (
                      <div className="education-section">
                        <h3 className="subsection-title">{sport.detailedContent.director.education.title}</h3>
                        <p className="education-description">{sport.detailedContent.director.education.description}</p>
                      </div>
                    )}

                    {sport.detailedContent.director.currentProjects && (
                      <div className="current-projects-section">
                        <h3 className="subsection-title">{sport.detailedContent.director.currentProjects.title}</h3>
                        <p className="projects-description">{sport.detailedContent.director.currentProjects.description}</p>

                        <div className="projects-grid">
                          {sport.detailedContent.director.currentProjects.components.map((component, index) => (
                            <div key={index} className="project-card">
                              <h4 className="project-title">{component.title}</h4>
                              <p className="project-description">{component.description}</p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {sport.detailedContent.director.futureVision && (
                      <div className="future-vision-section">
                        <h3 className="subsection-title">{sport.detailedContent.director.futureVision.title}</h3>
                        <p className="vision-description">{sport.detailedContent.director.futureVision.description}</p>
                      </div>
                    )}

                    {sport.detailedContent.director.qualifications && (
                      <div className="qualifications-section">
                        <h3 className="subsection-title">{sport.detailedContent.director.qualifications.title}</h3>

                        <ul className="qualifications-list">
                          {sport.detailedContent.director.qualifications.components.map((qualification, index) => (
                            <li key={index} className="qualification-item">{qualification}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}

                {sport.detailedContent.conclusion && (
                  <div className="conclusion-section">
                    <p className="conclusion-text">{sport.detailedContent.conclusion}</p>
                  </div>
                )}
              </div>
            )}
          </div>





          {/* <h2 className='our-services'>Our Services</h2> */}
          <div className="services-grid">
            {/* Turnkey Sports Infrastructure Development */}

            {/* <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Turnkey Sports Infrastructure</h3>
                <p className="service-description">Complete sports facility development from planning to execution</p>
                <button className="service-btn" onClick={() => handleLearnMore('turnkey-sports-infrastructure')}>Learn More</button>
              </div>
            </div> */}

            {/* Sports Flooring Solutions */}

            {/* <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1546519638-68e109498ffc?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Sports Flooring Solutions</h3>
                <p className="service-description">Professional flooring for all sports and activities</p>
                <button className="service-btn" onClick={() => handleLearnMore('sports-flooring-solutions')}>Learn More</button>
              </div>
            </div> */}

            {/* Ground Development */}
            {/* <div className="service-card" style={{
              backgroundImage: 'url(https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400&h=300&fit=crop&crop=center)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="service-overlay"></div>
              <div className="service-content">
                <h3 className="service-title">Ground Development</h3>
                <p className="service-description">Complete ground development and infrastructure solutions</p>
                <button className="service-btn" onClick={() => handleLearnMore('ground-development')}>Learn More</button>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building.
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <a href="#" className="view-more">View More...</a>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="#" className="footer-link active">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="#" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 36/B Lane no.5 dharm park shyam nagar-2 Rajasthan/Jaipur - 302019</div>
                <div className="contact-item">📞 +91-9414050348</div>
                <div className="contact-item">✉️ askmesportsalliance@gmail.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src={logo} alt="Sports Infrastructure Solutions Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ASK ME SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 ASK ME SPORTS ALLIANCE. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default SportsPage;
